import React from 'react';
import './Pages.css';
import Header from "../header/Header";
import Footer from "../footer/Footer";

const ESAE = () => {
    return (<div className="page-wrapper">
        <Header/>
        <div className="about-us">
            <p>Η Ένωση Σπάνιων Ασθενών Ελλάδος (Ε.Σ.Α.Ε.) είναι ένα Σωματείο μη κερδοσκοπικού χαρακτήρα, με έδρα την
                Αθήνα και περιφέρεια ολόκληρη την Ελληνική Επικράτεια, που συγκεντρώνει υπό τη σκέπη του 31 Συλλόγους,
                Σωματεία και ΑΜΚΕ με ασθενείς που ζουν με Σπάνιες Ασθένειες και Νοσήματα.</p>
            <p>Ειδικότερα, αποτελεί τον μεγαλύτερο φορέα εκπροσώπησης των Σπάνιων Ασθενών και των αναγκών τους στην
                Ελλάδα, με μέλη σε Επιτροπές και Ομάδες Εργασίας, όπως στην Επιτροπή Σπάνιων Νοσημάτων, στην Ομάδα
                Εργασίας Μητρώου για τα Σπάνια Νοσήματα και Θεραπευτικών Πρωτοκόλλων, καθώς και στην Επιτροπή
                Φαρμακευτικής Δαπάνης του υπουργείου Υγείας.</p>
            <p>Παράλληλα, είναι ο επίσημος φορέας εκπροσώπησης της Ελλάδας στο εξωτερικό, μέλος του <a
                href="https://www.eurordis.org/" target="_blank" rel="noopener noreferrer">Ευρωπαϊκού Οργανισμού Σπανίων
                Παθήσεων (EURORDIS)</a>, του <a href="https://www.rarediseasesinternational.org/" target="_blank"
                                                rel="noopener noreferrer">Παγκόσμιου Οργανισμού Σπανίων Παθήσεων (Rare
                Diseases International)</a>, και του Συμβουλίου των Εθνικών Ενώσεων της Ευρώπης μέσω του <a
                href="https://www.eurordis.org/who-we-are/our-members/national-alliances-for-rare-diseases/"
                target="_blank" rel="noopener noreferrer">Council of National Alliances</a>.</p>
        </div>
        <Footer/>
    </div>);
};

export default ESAE;